/**
 * Same-origin /phpmail.php when deployed with PHP (DreamHost + public/phpmail.php).
 * Override with VITE_PHP_MAIL_URL for a remote endpoint if needed.
 */
export const PHP_MAIL_URL =
  import.meta.env.VITE_PHP_MAIL_URL?.trim() || '/phpmail.php';
